import { styled } from "styled-components";
import johnwanderaAbt from "../../assets/images/johnwanderaAbt.png";
import { Name } from "../common/gradientProps";
import { QuirkyCircleProps } from "../common/types";
import { useState } from "react";

const QuirkyImage = styled.img`
  max-width: 360px;
  max-height: 480px;
  border-radius: 9px;
  margin-right: 5rem;

  @media (max-width: 992px) {
    margin: 0 0 3rem 0;
  }
  @media (max-width: 576px) {
    max-width: 90%;
  }
`;

const Placeholder = styled.div`
  min-width: 360px;
  min-height: 480px;
  border-radius: 9px;
  margin-right: 5rem;
  //   background-color: #f0f0f0;
  border: 1px solid ${({ theme }) => theme.text};

  @media (max-width: 992px) {
    margin: 0 0 3rem 0;
  }
  @media (max-width: 576px) {
    min-width: 90%;
  }
`;

export const QuirkyCircle = styled.div<QuirkyCircleProps>`
  border-radius: 50%;
  border: 1px solid
    ${({ theme, $borderColor }) => $borderColor || theme.circularIconBg};
  height: ${({ $size }) => $size || "14px"};
  width: ${({ $size }) => $size || "14px"};
  margin-bottom: 1rem;
`;

const QuirkyContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.circularIconBg};
  font-weight: 300;
  padding: 1rem;
  border-radius: 9px;
`;

function QuirckyInsights() {
  const [imageLoaded, setImageLoaded] = useState(true);

  const handleImageError = () => {
    setImageLoaded(false); // Switch to placeholder if the image fails to load
  };

  return (
    <div className="d-flex flex-row flex-wrap justify-content-center align-items-center">
      {imageLoaded ? (
        <QuirkyImage
          src={johnwanderaAbt}
          alt="John Wandera Abt"
          onError={handleImageError}
        />
      ) : (
        <Placeholder />
      )}

      <div className="d-flex flex-column justify-content-between col-lg-5">
        <span style={{ marginBottom: "1rem", fontWeight: "200" }}>
          <Name className="App-extreme-big-font2">Q</Name>uirky Insights
        </span>
        <div className="d-flex justify-content-start">
          <QuirkyContainer>
            <QuirkyCircle />
            <p>
              I like Art, Anime, Music, Pets & Video Games. <br />
              <br />
              Building robust backend logic feels like unlocking a superpower. I
              love simplifying complex flows and designing systems that just
              work. <br />
              <br />
              Anime fuels my drive to go beyond limits. Art transforms my
              reality, music sets the tone, and pets keep things grounded. As
              for video games—those zombies still aren't going to defeat
              themselves!
            </p>
          </QuirkyContainer>
        </div>
      </div>
    </div>
  );
}

export default QuirckyInsights;
